export const DESCRIPTIVE_BADGE_VARIANTS = {
  PRIMARY: 'primary',
  ERROR: 'error',
  WARNING: 'warning',
  SUCCESS: 'success',
  DEFAULT: 'default',
  DISABLED: 'disabled',
  REGULAR: 'regular'
};

export const DESCRIPTIVE_BADGE_SIZES = {
  XSMALL: 'xsmall',
  SMALL: 'small',
  LARGE: 'large'
};
